export default __webpack_public_path__ + "static/media/Retail_App_Icon.84c5aeeb.svg";